/**
 * @param {ReduxState} state - The Redux state.
 * @returns {SeasonLeadersState} The Season Leaders state.
 */
export const seasonLeadersSelector = (state) => state.statspro.seasonLeaders;
